import { render } from "./select-receipt-language-v2.vue?vue&type=template&id=70c95b86&scoped=true&ts=true"
import script from "./select-receipt-language-v2.vue?vue&type=script&lang=ts"
export * from "./select-receipt-language-v2.vue?vue&type=script&lang=ts"

import "./select-receipt-language-v2.vue?vue&type=style&index=0&id=70c95b86&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c95b86"]])

export default __exports__